import { render, staticRenderFns } from "./DiscontinuedApplications.vue?vue&type=template&id=21493cd0&"
import script from "./DiscontinuedApplications.vue?vue&type=script&lang=js&"
export * from "./DiscontinuedApplications.vue?vue&type=script&lang=js&"
import style0 from "./DiscontinuedApplications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports